import React, { useState } from 'react'
import SearchNot from '../../images/searchNot.png'
import { Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import ReportIcon from '@mui/icons-material/Report';
import FemaleIcon from '@mui/icons-material/Female';
import {  ArrowBack, ArrowForward, CycloneOutlined, DateRange, Sell, Sensors } from '@mui/icons-material'
import { useGlobalContext } from '../Context';
import CattleHistoryCompare from '../HistoryCompare/CattleHistoryCompare';
import useHistory from '../CustomHooks/useHistory';
import SensorHistoryCompare from '../HistoryCompare/SensorHistoryCompare';
import EmptyReturn from '../EmptyReturn';
const moment=require('moment-jalaali')

const SensorHistoryParameterCard = ({data}) => {
    console.log(data)
  const {isOpenModal,closeModalls,openModalls}=useGlobalContext();
  const [SData,setSdata]=useState('')
  return (
    <Container className='allCardsCon'>
     <Row style={{width:'100%'}}>
     {
        data?.length?data.map((item,index)=>{
            const {entryDate}=item;
                    const birth=entryDate?.substring(0,10);
                    const pbirth=moment(birth).format('jYYYY-jMM-jDD')
            return <div key={index} style={{display:'flex', flexWrap:'wrap',gap:'4px'}} className='  col-sm-12 col-md-6 col-lg-4 col-xl-3 col-xxl-3 gap-3'>
                <div  className='ThemeCard' style={{borderRight:'2px solid #7FB020'}}>
            
            
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <DateRange/>
                </span>
                    </div></div>
                <span>تاریخ  :</span>
                <span>{pbirth}</span>
            </div>
            <div  onClick={()=>{
                      setSdata(item);openModalls()
                    }} className='btnCardDAm'>مشاهده</div>
          </div>
            </div>
        })
     :<EmptyReturn/>}
     </Row>
     {isOpenModal&&<SensorHistoryCompare data={SData?.currentJson} data2={SData?.newJson}/>}
    </Container>
  )
}

export default SensorHistoryParameterCard
